import React from 'react';
import PropTypes from 'prop-types';

export default function EmptyIconWithText({
  size, contentClassName, wrapperClassName, children,
}) {
  return (
    <div className={`icon-with-text ${wrapperClassName}`}>
      <div
        className="icon-bg bg-gray-200"
        style={{ height: size }}
      >
        <i
          className="photo-placeholder-icon bg-gray-700"
          style={{ minHeight: size, minWidth: size }}
        />
      </div>

      {children && (
        <div className={`text-content ${contentClassName}`}>
          {children}
        </div>
      )}
    </div>
  );
}

EmptyIconWithText.propTypes = {
  size: PropTypes.string,
  contentClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  children: PropTypes.node,
};

EmptyIconWithText.defaultProps = {
  size: '64px',
  contentClassName: '',
  wrapperClassName: '',
  children: null,
};
